var _g, _g2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGradient1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 384,
    height: 596,
    viewBox: "0 0 384 596",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_80_141563)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 183.637,
    cy: 183.637,
    r: 183.637,
    transform: "matrix(-0.654624 -0.755955 -0.755955 0.654624 277.642 248.477)",
    fill: "url(#paint0_linear_80_141563)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_80_141563)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 59.4634,
    cy: 134.368,
    rx: 59.4634,
    ry: 134.368,
    transform: "matrix(-0.654624 -0.755955 -0.755955 0.654624 100.532 20.428)",
    fill: "url(#paint1_linear_80_141563)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_80_141563",
    x: -346.723,
    y: -135.462,
    width: 730.661,
    height: 730.661,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 90.8454,
    result: "effect1_foregroundBlur_80_141563"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_80_141563",
    x: -239.625,
    y: -126.211,
    width: 399.309,
    height: 379.295,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 45.4227,
    result: "effect1_foregroundBlur_80_141563"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_80_141563",
    x1: 183.637,
    y1: 0,
    x2: 183.637,
    y2: 367.274,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC465",
    stopOpacity: 0.38
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC56F",
    stopOpacity: 0.06
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_80_141563",
    x1: 73.4586,
    y1: 80.1253,
    x2: 57.8507,
    y2: 81.0607,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCA00D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F58A25",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#09090B",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGradient1);
export default __webpack_public_path__ + "static/media/Gradient-1.3f25147fc1f8485db37b07e0bb2bb8ca.svg";
export { ForwardRef as ReactComponent };